module.exports = __webpack_public_path__ + "img/intro_4.d8f0e1f.png";